import { useMutation, useQuery } from "@tanstack/react-query";
import React from "react";

import DataSvc from "../../../../services/dataSvc";
import { FeatureNames } from "../types/featureNames";
import { KeywordReviewCrossAnalysisResponse } from "../types/keywordReviewCrossAnalysisData";

export const useExperimentalOrganizationFeature = (
  featureName: FeatureNames,
  organizationId: string | null | undefined
) => {
  const query = useQuery<KeywordReviewCrossAnalysisResponse>({
    queryKey: ["experimentalOrganizationFeature", featureName, organizationId],
    queryFn: () => {
      return DataSvc.EXPERIMENTAL_getOrganizationFeatures({
        featureName,
        organizationId: organizationId as string
      });
    },
    enabled: !!organizationId
  });

  const mutation = useMutation({
    mutationFn: () => {
      return DataSvc.EXPERIMENTAL_generateOrganizationFeatureData({
        featureName,
        organizationId: organizationId as string
      });
    },
    onSuccess: () => {
      query.refetch();
    }
  });

  // When the status is 'generating', refetch the data every few seconds
  React.useEffect(() => {
    if (query.data?.data?.status !== "generating") {
      return;
    }

    const intervalFunction = () => {
      query.refetch();
    };

    const interval = setInterval(intervalFunction, 3000);
    return () => clearInterval(interval);
  }, [query]);

  return { ...query, generate: mutation.mutateAsync };
};
